import { useCallback } from 'react';
import { Button } from 'bf-ui';

import styles from './cookieInfo.section.scss';
import CookiesEnum from '../../../enums/cookies.enum';

import { setItem } from '../../../helpers/cookie.helper';

export default function CookieInfoSection({ onClose }) {
  const onGotIt = useCallback(() => {
    setItem(CookiesEnum.COOKIE_POLICY, 'true', true);
    if (onClose) {
      onClose();
    }
  }, []);
  return (
    <>
      <div className="cookie_info_section">
        <span>
          This website uses cookies to ensure you get the best experience on our
          website.{' '}
          <a href="/cookie-policy" target="_blank" rel="noreferrer">
            <abbr title="Cookie policy">Cookie policy</abbr>
          </a>
        </span>
        <Button variant="contained" onClick={onGotIt}>
          Got it!
        </Button>
      </div>
      <style jsx>{styles}</style>
    </>
  );
}
